var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHighRisk(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 10.4 13.584",
    viewBox: "0 0 10.4 13.584",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#13ACC5",
    d: "M10.399 2.219v-.016h-.015C9.257.873 7.356 0 5.2 0S1.143.873.015 2.203H.006v.01C.001 4.336 0 5.704 0 7.832v1.096c.271.589 4.458 4.428 5.2 4.656.742-.228 4.929-4.067 5.2-4.656V7.832l-.001-5.613zM8.167 5.08C6.986 6.387 6.21 7.235 5.015 8.498l-.648.684L2.221 6.7c-.305-.354-.264-.885.092-1.188.356-.303.892-.263 1.198.091l.912 1.055c.851-.908 1.534-1.657 2.478-2.702.312-.346.85-.376 1.2-.065.349.31.379.842.066 1.189z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighRisk);
export default __webpack_public_path__ + "static/media/high_risk.6d88f7bcef82ff2c01b2ff9ab258fdac.svg";
export { ForwardRef as ReactComponent };